
import { singleton } from "../fable_modules/fable-library-js.5.0.0-rc.2/AsyncBuilder.js";
import { Headers_cacheControl, Http_header, Http_request, Http_method, Http_send } from "../fable_modules/Fable.SimpleHttp.3.6.0/Http.fs.js";
import { HttpMethod } from "../fable_modules/Fable.SimpleHttp.3.6.0/Types.fs.js";
import { checkBuildDate, addPrefix } from "../CommunicationV2.js";
import { iterate } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { toArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { tryFind } from "../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { printf, toFail } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Cmd_OfAsyncWith_either } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { AsyncHelpers_start } from "../fable_modules/Fable.Elmish.5.0.2/prelude.fs.js";

function fetchHealth() {
    return singleton.Delay(() => {
        let req_1;
        return singleton.Bind(Http_send((req_1 = Http_method(new HttpMethod(0, []), Http_request(addPrefix("/api/health"))), Http_header(Headers_cacheControl("no-cache"), req_1))), (_arg) => {
            let matchValue;
            const response = _arg;
            return singleton.Return((matchValue = (response.statusCode | 0), (matchValue === 200) ? ((iterate((buildDate) => {
                checkBuildDate(buildDate);
            }, toArray(tryFind("build-date", response.responseHeaders))), response.responseText)) : toFail(printf("health endpoint responded with %i"))(matchValue)));
        });
    });
}

export function getHealth(successMsg, errorMsg) {
    return Cmd_OfAsyncWith_either((x) => {
        AsyncHelpers_start(x);
    }, fetchHealth, undefined, successMsg, errorMsg);
}

